module.exports = __webpack_public_path__ + "img/hr-tree-01-b-trunk.cd15f2da.png";